import './OkulyonetimOtherFilter.scss'

import { Checkbox, Collapse, Input } from 'antd'
import React, { useState } from 'react'
import { trNormalize } from 'utils/helpers'

import { OkulyonetimOtherFilterType } from './type'

const { Panel } = Collapse

const OkulyonetimOtherFilter: React.FC<OkulyonetimOtherFilterType> = (props) => {
  const { title, searchbar, options, onChange, checkedTempKeys } = props
  const sortedOptions = [...options].sort((a, b) => b.count! - a.count!)
  const [selectedOptions, setSelectedOptions] = useState<string[]>(
      sortedOptions.filter((option) => option.isSelected === true).map((option) => option.value!)
  )

  const [filteredUsers, setFilteredUsers] = useState(sortedOptions)

  const handleFilter = (value: string) => {
    const trimmedValue = trNormalize(value.trim())
    if (trimmedValue === '') {
      setFilteredUsers(options)
      return
    }

    const filteredItems = options.filter((item) => trNormalize(item.title).includes(trimmedValue))
    setFilteredUsers(filteredItems)
  }
  const handleCheckboxChange = (value: string) => {
    setSelectedOptions((prevSelectedOptions) => {
      const updatedSelectedOptions = prevSelectedOptions.includes(value)
        ? prevSelectedOptions.filter((option) => option !== value) // Seçiliyse kaldır
        : [...prevSelectedOptions, value] // Seçili değilse ekle
      if (selectedOptions) {
        console.log(selectedOptions)
      }
      // Güncel seçili değerleri dışarı aktar
      onChange?.([...updatedSelectedOptions])

      return updatedSelectedOptions
    })
  }
  return (
    <div className="db-okulyonetim-other-filter">
      <Collapse
        expandIconPosition="end"
        bordered={false}
        defaultActiveKey={['1']}
      >
        <Panel header={title} key="1">
          {searchbar && (
            <div className="okulyonetim-other-filter-search">
              <Input onChange={(e) => handleFilter(e.target.value)} />
            </div>
          )}
          <div className="okulyonetim-other-filter-options">
            {filteredUsers.map((option, index) => (
              <div key={index}>
                <Checkbox
                  checked={checkedTempKeys.includes(option.value!)} // `selectedOptions` içinde olup olmadığını kontrol et
                  onChange={() => handleCheckboxChange(option.value!)} // Seçimi değiştir
                >
                  <div className="okulyonetim-checkbox-filter-option">
                    <span className="okul-yonetim-title">
                      {option.title.length > 30 ? `${option.title.substring(0, 30)}...` : option.title === " " ? "Diğerleri" : option.title}
                    </span>
                    <span className="okul-yonetim-count">{option.count}</span>
                  </div>
                </Checkbox>
              </div>
            ))}
          </div>
        </Panel>
      </Collapse>
    </div>
  )
}

export default OkulyonetimOtherFilter
